module.exports = __webpack_public_path__ + "static/media/folder.6993bf70.jpg";